"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __importDefault(require("@gin-betting/core"));
var lodash_1 = require("lodash");
var utils_1 = require("./utils");
var extendSearchString = core_1.default.utils.extendSearchString, GROUP_GET_MATCHES_REQUEST = core_1.default.entities.constants.GROUP_GET_MATCHES_REQUEST;
function middleware(routes) {
    return function (store) { return function (next) { return function (action) {
        var groupType = lodash_1.get(action, ['meta', 'group']);
        if (groupType !== GROUP_GET_MATCHES_REQUEST)
            return next(action);
        var pagination = store.getState().pagination;
        var initialLoad = pagination.initialLoad, enabled = pagination.enabled;
        /* remove page from url if pagination not enabled */
        if (initialLoad && !enabled) {
            extendSearchString('page', null);
        }
        var _a = action.payload, variables = _a.variables, args = _a.args;
        var isPolling = args.isPolling, isLoadMore = args.isLoadMore;
        var _b = utils_1.getOffsetAndLimit({
            pagination: pagination,
            isPolling: isPolling,
            isLoadMore: isLoadMore,
        }, routes), limit = _b.limit, offset = _b.offset, customInitialLoad = _b.customInitialLoad, prepend = _b.prepend;
        action.payload.variables = __assign(__assign({}, variables), { limit: limit,
            offset: offset });
        action.payload.args = __assign(__assign({}, args), { customInitialLoad: customInitialLoad,
            prepend: prepend });
        return next(action);
    }; }; };
}
exports.default = middleware;
//# sourceMappingURL=middleware.js.map